import { api } from '../../../../api/configs/axiosConfigs';

export interface PublicPropertyDetail {
  id: string;
  address: string;  // Flattened format from backend
  beds: number;
  baths: number;
  sqft: number;
  listPrice: number;
  listPricePerSqft: number;
  equity: number | null;
  avm: number | null;
  avmPerSqft: number | null;
  daysOnMarket: number;
  imgUrl: string;
  status: string;
  daysSinceSold: number;
  annualTaxes: number;
  taxAssessedValue: number;
  yearBuilt: number;
  subdivision: string;
  garage: number;
}

let abortController: AbortController | null = null;

export async function fetchPublicPropertyDetail(
  propertyId: string
): Promise<PublicPropertyDetail> {
  if (abortController) {
    abortController.abort();
  }

  abortController = new AbortController();

  try {
    const response = await api.get(
      `/public/property_detail/${propertyId}`,
      { signal: abortController.signal }
    );
    return response.data;
  } catch (error) {
    if (error.name === 'CanceledError' || error.name === 'AbortError') {
      console.log('Request cancelled:', propertyId);
      throw error;
    }
    console.error('Error fetching public property detail:', error);
    throw error;
  }
}
